import React, { useState, useEffect } from 'react';
import { HelpCenterService } from '$/services';
import * as Bixby from '$/core';
import { connect } from 'react-redux';
import { downloadFile } from '$/store/export/actions';
import groupBy from 'lodash/groupBy';
import Loading from '$/components/loading/Loading';
import classnames from 'classnames';
import UserGuideItem from './userGuideItem';
import HelpCenterNavigation from '../HelpCenterNavigation';
import '../index.scss';

interface IClientHelpCenterBaseProps {
  ignoreAccordion?: boolean;
  type: Bixby.Enums.HelpCenterItemType;
  dispatchDownloadFile: (blob: Blob, filename: string) => Promise<void>;
}

const ClientHelpCenterBase: React.FC<IClientHelpCenterBaseProps> = ({
  dispatchDownloadFile,
  type,
  ignoreAccordion,
}) => {
  const [helpCenterItems, setHelpCenterItems] = useState<Bixby.Models.HelpCenterItem[]>();
  const [helpCenterItemsGrouped, setHelpCenterItemsGrouped] = useState<{
    [key: string]: Bixby.Models.HelpCenterItem[];
  }>();
  const [isLoading, setIsLoading] = useState(false);

  let typeString = '';
  if (type === Bixby.Enums.HelpCenterItemType.Document) {
    typeString = 'user guides';
  } else if (type === Bixby.Enums.HelpCenterItemType.Video) {
    typeString = 'video tutorials';
  } else {
    typeString = 'excel plugin material';
  }

  useEffect(() => {
    const getAll = async () => {
      const results = await HelpCenterService.getByType(type);

      const filtered = results.filter(_ => _.type === type);
      setHelpCenterItems(filtered);
      setHelpCenterItemsGrouped(groupBy(filtered, _ => _.helpCenterCategory_Name));
      setIsLoading(false);
    };
    setIsLoading(true);
    getAll();
  }, [type]);

  const handleDownload = async (id: string) => {
    const result = await HelpCenterService.download(id);
    if (result && result.filename) {
      dispatchDownloadFile(result.blob, result.filename);
    }
  };
  const content = isLoading ? (
    <Loading pageLevel />
  ) : Bixby.Utils.isNullOrEmpty(helpCenterItems) ? (
    <p>Stay tuned for {typeString} coming soon.</p>
  ) : (
    <div className={classnames('user-guides', { 'simple-layout': ignoreAccordion })}>
      {helpCenterItems ? (
        ignoreAccordion ? (
          helpCenterItems.map((_, ix) => (
            <div key={ix} className="fake-link" onClick={() => handleDownload(_.id)} role="button">
              {_.title}
            </div>
          ))
        ) : (
          helpCenterItemsGrouped &&
          Object.keys(helpCenterItemsGrouped).map((key, ix) => (
            <UserGuideItem
              key={ix}
              title={key}
              userGuides={helpCenterItemsGrouped[key]}
              onDownloadClick={handleDownload}
              type={type}
            />
          ))
        )
      ) : (
        <p>Stay tuned for {typeString} coming soon.</p>
      )}
    </div>
  );

  return <HelpCenterNavigation>{content}</HelpCenterNavigation>;
};

const mapDispatchToProps = (dispatch: any) => ({
  dispatchDownloadFile: (blob: Blob, filename: string) => dispatch(downloadFile(blob, filename)),
});

export default connect(null, mapDispatchToProps)(ClientHelpCenterBase);
